import Vue from 'vue'
let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  intro: [
    {
      name: '',
      txt: [
        '中德人工智能研究院于2017年6月在李克强总理和默克尔总理共同见证下成立，由四维时代与德国人工智能研究中心共同组建，旨在利用中德两国技术优势，推进人工智能视觉技术的发展及应用。',
        '四维看看Pro是这一中德合作项目的阶段性硬件成果，于2019年5月在德国柏林首次亮相，该产品运用最新技术打破了美国品牌在该领域的技术垄断，大大降低了三维建模的硬件和时间成本。',
        '在四维看看Pro之前，中德人工智能研究院于2018年5月率先推出全球首款消费级3D相机四维看看Lite。'
      ],
      img: baseUrl + 'images/cgaii-logo.png'
    },
    {
      name: '',
      txt: [
        '四维时代（4DAGE）创立于2014年10月，致力于人工智能三维数字化技术的理论研究与应用，以实现“数字万物”为愿景，让数字化飞入寻常百姓家。作为国内首家3D数字化重建技术中心，也是第一家真正提供3D展示技术的公司，四维时代在国际上首创的微米级三维数字化精细扫描技术，较传统三维建模方式在效率上提高200倍以上，远超美国Adobe公司的厘米级精度。目前世界上能做到这个精度的只有两家，一家是四维时代，另一家是MIT计算视觉实验室。',
        '目前，四维时代的解决方案及产品服务于包括故宫博物院、汉代海昏侯国遗址博物馆、世博会等全国各大博物馆及国际级展会，及港珠澳大桥的虚拟现实数字化模拟等国家重大工程项目，涵盖工业智能化、智慧城市、房地产、新零售等领域。'
      ],
      img: baseUrl + 'images/fdage-logo.png'
    }
  ],
  events: {
    title: '大事记',
    nodes: [
      {
        year: '2014年',
        txt: [
          '<span>10月</span>四维时代创立，成员在人工智能三维数字化重建及数字化虚拟展示技术方面具有世界领先的科研实力。',
          '<span>12月</span>建模精度达微米级的一种基于光栅扫描的物体数字化三维重建装置，获专利授权。'
        ]
      },
      {
        year: '2015年',
        txt: [
          '<span>8月</span>“高精度一键式三维数字化重建及其展示”获“中国创翼”青年创业创新大赛三等奖。',
          '<span>10月</span>四维时代CEO作为全国双创代表获得李克强总理接见，并向总理汇报工作。',
          '<span></span>相继成为故宫博物院、广东省博物馆等文物保护机构的合作伙伴。'
        ]
      },
      {
        year: '2016年',
        txt: [
          '<span>5月</span>为中国十大考古发现之一—南昌汉代海昏侯国遗址博物馆打造的线上数字博物馆上线。'
        ]
      },
      {
        year: '2017年',
        txt: [
          '<span>4月</span>成为阿斯塔纳世博会中国馆虚拟现实技术唯一指定供应商。',
          '<span>6月</span>在中德两国总理见证下与德国人工智能研究中心签约《中德人工智能研究院项目》，为中德科技交流建立有力纽带。'
        ]
      },
      {
        year: '2018年',
        txt: [
          '<span>5月</span>推出全球首款消费级3D相机四维看看，10分钟即可复刻100平米空间。',
          '<span>11月</span>中国高科技产业化研究会授予四维看看“科学技术成果”称号。',
          '<span></span>中国国际高新技术成果交易会授予四维看看“优秀产品奖”。'
        ]
      },
      {
        year: '2019年',
        txt: [
          '<span>4月</span>为黑提恩斯-德国国立陶瓷博物馆展馆及馆藏进行三维数字化重建，并开发数字博物馆App，该案例作为一带一路文化输出的杰出代表入选第二届一带一路峰会案例集。',
          '<span>5月</span>四维看看Pro在德国柏林人工智能大会上亮相。'
        ]
      }
    ]
  },
  kefu: [
    {
      title: '联系我们',
      class: 'lxwm',
      content: [
        '公司：珠海市四维时代网络科技有限公司',
        '地址：广东省珠海市高新区唐家湾港湾大道南港湾一号'
      ]
    },
    {
      title: '客户服务',
      class: 'khfw',
      content: ['客服售后：4006698025', '电子邮件：service@4dage.com']
    },
    {
      title: '媒体采访',
      class: 'mtcx',
      content: ['电子邮件：pr@4dage.com']
    },
    {
      title: '销售合作',
      class: 'ywhz',
      content: ['热线：0756-6996796 / 6996791', '电子邮件：sales@4dage.com']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/language/cn/about.js